export const maskEmail = {
    name: 'Email',
    description: 'Mask all email addresses except for the anwb.nl domain',
    exceptions: ['@anwb.nl', 'unigarant.nl'],
    filterRegex: /([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+)/g,
};
//# sourceMappingURL=email-filter.js.map